import React from 'react'

const Manual_admin_abono_a_cuenta_personal_clientes = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
    <div className="mt-16">
     <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
     Admin - Abono a Cuenta Personal Clientes
     </h2>
     <p className="text-lg text-gray-700 mb-6">
      Esta guía facilita la gestión de depósitos en cuentas personales de clientes,
      asegurando un registro preciso de cada transacción. Con estos pasos, podrá
      agregar depósitos, indicar el método de pago y consultar el historial de
      transacciones. Es clave para quienes administran cuentas clientes optimizar su
      trabajo y mantener un control financiero impecable.
     </p>
     <iframe
          src="https://scribehow.com/embed/Admin__Abono_a_Cuenta_Personal_Clientes__chA_tfGQRXCJby3QRRtzWA?as=scrollable"
          className="scribe-iframe-general-2"
          width="100%"
          height="4960"
          allowFullScreen
          style={{
            aspectRatio: '1 / 1',
            border: 0,
            minHeight: '480px'
          }}
        ></iframe>
   </div>
   </div>
  )
}

export default Manual_admin_abono_a_cuenta_personal_clientes